export default {"src":"/_next/static/media/LINK.926ff0ad.svg","height":44,"width":38,"blurWidth":0,"blurHeight":0};